const wiki = {
  search: "Search wiki...",
  allCategories: "All categories",
  newEntry: "New entry",
  noEntries: "No wiki entries",
  noEntriesDesc: "Create your first entry to start building the knowledge base",
  noResults: "No results found",
  tryDifferentSearch: "Try different search terms",
  title: "Title",
  description: "Description",
  category: "Category",
  qaPairs: "Q&A Pairs",
  question: "Question",
  answer: "Answer",
  addQaPair: "Add Q&A pair",
  removeQaPair: "Remove",
  save: "Save",
  saving: "Saving...",
  saved: "Saved",
  cancel: "Cancel",
  create: "Create entry",
  creating: "Creating...",
  backToWiki: "Back to wiki",
  editEntry: "Edit entry",
  deleteEntry: "Delete entry",
  confirmDelete: "Delete this entry permanently?",
  entries: "entries",
  lastUpdated: "Last updated",
  uncategorized: "Uncategorized",
  titleRequired: "Title is required",
  categories: {
    sales: "Sales",
    ops: "Operations",
    tech: "Technology",
    people: "People",
    products: "Products",
  },
} as const;
export default wiki;
